import { Popconfirm } from "antd";

function LinkButton({ props }) {
  return (
    <>
      {props.popConfirmLabel && (
        <Popconfirm title={props.popConfirmLabel} onConfirm={props.onConfirm}>
          <span
            onClick={props.onClick}
            className="cursor-pointer p-2 d-flex align-items-center gap-1"
          >
            {props.prefix && props.icon}
            <span className={props.className}>{props.label}</span>
            {props.postfix && props.icon}
          </span>
        </Popconfirm>
      )}
      {!props.popConfirmLabel && (
        <span
          onClick={props.onClick}
          className="cursor-pointer p-2 d-flex align-items-center gap-1"
        >
          {props.prefix && props.icon}
          <span className={props.className}>{props.label}</span>
          {props.postfix && props.icon}
        </span>
      )}
    </>
  );
}
export default LinkButton;
